import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import {
	PrimaryButton,
	ActiveButton,
	InactiveButton,
	DropdownButton,
	LinkButton,
	CancelButton,
	GreenButton,
	TransparentButton
} from './StyledButton'
import { Loading } from 'media/icons'

const Button = ({ text = '', onClick, icon, className, ...props }) => {
	const { status, loading } = props
	/* this is used for compatibility with other components' stylesheets (non-styled-components) */
	const oldClassName = cn(`btn btn-${status}`, { 'btn-fwidth': props.fWidth, 'btn-shrink': props.shrink }, className)

	const handleClick = e => {
		if (status === 'inactive' || loading) {
			e.preventDefault()
		} else if (onClick) {
			onClick(e)
		}
	}

	const buttonProps = {
		...props,
		className: oldClassName,
		onClick: handleClick,
		children: (
			<React.Fragment>
				{icon && icon()}
				{text}
				{loading && <Loading className='loading-ico' />}
			</React.Fragment>
		)
	}

	switch (status) {
		case 'primary':
			return <PrimaryButton {...buttonProps} />
		case 'active':
			return <ActiveButton {...buttonProps} />
		case 'inactive':
			return <InactiveButton {...buttonProps} />
		case 'dropdown':
			return <DropdownButton {...buttonProps} />
		case 'link':
			return <LinkButton {...buttonProps} />
		case 'cancelation':
			return <CancelButton {...buttonProps} />
		case 'green':
			return <GreenButton {...buttonProps} />
		case 'transparent':
			return <TransparentButton {...buttonProps} />
		default:
			return null
	}
}

Button.propTypes = {
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	type: PropTypes.oneOf(['submit', 'reset', 'button']),
	icon: PropTypes.element,
	status: PropTypes.oneOf(['active', 'primary', 'inactive', 'cancelation', 'link', 'dropdown', 'green', 'transparent']),
	onClick: PropTypes.func,
	fWidth: PropTypes.bool,
	shrink: PropTypes.bool,
	loading: PropTypes.bool,
	wMargin: PropTypes.bool
}

Button.defaultProps = {
	status: 'primary',
	type: 'button',
	fWidth: false,
	shrink: false,
	wMargin: false
}

export default Button
